import React from 'react';
import { Link } from 'react-router-dom';
import { UserRole } from '../../shared/types';
import { Table } from 'react-bootstrap';
import * as Site from '../../shared/Site';
import { Translate } from '../../shared/LanguageService';
import OrderStatusesIcons from '../statusicons/StatusIcons';
import OrderListTableCell from '../../components/common/OrderListTableCell';
import ProductPropertiesIcons from '../propertyIcons/ProductPropertiesIcons';

const MobileOrderTable = ({ orders, userRole, productsToExclude, openModal }) => {
    return (
        <Table className="order-table table-nopadding" hover responsive>
            <tbody>
                {orders.map((order: any, index: number) => {
                    const orderLink = `/orders/${order.orderId}/image`;

                    let rowClass = Site.getOrderCssClass(order.site);
                    if (order.isExpress) {
                        rowClass += ' express';
                    } else if (order.isExpressWeekend) {
                        rowClass += ' express-weekend';
                    } else if (order.isEarlyDelivery) {
                        rowClass += ' early-delivery';
                    }

                    return (
                        <tr className={rowClass} key={index}>
                            <OrderListTableCell clickable={true} navigateTo={orderLink} className='no-paddings' fullsize>
                                <table className='smallscreen-table'>
                                    <tr>
                                        <th>{Translate('edited-orders/table/header/orderid')}</th>
                                        <td className='first-row'>
                                            <div className='first-row'>
                                                <span>
                                                    {order.orderCollectionNumber + ':' + order.orderNumber}
                                                </span>
                                                <div className='first-row-icons'>
                                                    <ProductPropertiesIcons
                                                        properties={userRole == UserRole.Photographer
                                                            ? order.productProperties.filter((property) => {
                                                                return property.value !== productsToExclude.find((x) => x === property.value);
                                                            })
                                                            : order.productProperties}
                                                    ></ProductPropertiesIcons>
                                                    {order.photographerIsEditor && (
                                                        <span className="property-icons">
                                                            <i
                                                                className="material-icons"
                                                                title={Translate(
                                                                    'order/photographer-is-editing/title'
                                                                )}
                                                            >
                                                                edit
                                                            </i>
                                                        </span>
                                                    )}
                                                    <OrderStatusesIcons
                                                        orderStatuses={order.orderStatuses}
                                                    ></OrderStatusesIcons>
                                                </div>
                                            </div>
                                            <div style={{ width: "50px", marginLeft: "8px" }}>
                                                <span className={!order.isApproved ? 'red' : ''}>
                                                    {order.isApproved && (
                                                        <i className="material-icons">check_circle</i>
                                                    )}
                                                    {!order.isApproved && (
                                                        <i className="material-icons">warning</i>
                                                    )}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{Translate('edited-orders/table/header/ordered')}</th>
                                        <td>{order.productName}</td>
                                    </tr>
                                    <tr>
                                        <th>{Translate('edited-orders/table/header/address')}</th>
                                        <td>{`${order.addressLine1}, ${order.addressCity}`}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {order.photographerInstruction &&
                                                order.photographerInstruction.length > 0 && (
                                                    <i
                                                        className="btn btn-default"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            openModal(order)
                                                        }}
                                                    >
                                                        <i className="material-icons">info</i>
                                                    </i>
                                                )}
                                        </td>
                                        <td>
                                            {order.planOrderId && order.isMeasured && (
                                                <Link
                                                    className="btn btn-default"
                                                    to={`/orders/${order.planOrderId}/plan`}
                                                    style={{ width: "160px" }}
                                                >
                                                    {Translate(
                                                        'edited-orders/table/button/go-to-measured-order'
                                                    )}
                                                </Link>
                                            )}
                                        </td>
                                    </tr>
                                </table>
                            </OrderListTableCell>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default MobileOrderTable;
